import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Actions
import { item as pesquisaitem } from '../../../../actions/produto/item';
import { pesquisa as pesquisapreco } from '../../../../actions/produto/prodprecos';
import { subitem as pesquisasubitem, subitemselecionado } from '../../../../actions/produto/subitem';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormProdutosPrecos from '../../components/forms/FormProdutosPrecos'
import Body from '../../components/layouts/body';


//Utils
import { getEvento } from '../../../../utils/eventosession';

class ProdutosPrecos extends React.Component {

    state = {
        pesquisamodal: false
    }

    componentDidMount(){
        const evento = getEvento();        
        this.props.pesquisaitem({idevento: evento.idevento, idpromotora: evento.idpromotora});
    }
    
    handleSubmit = (form) => {
        const evento = getEvento();        
        const dados = {
            ...form,
            iditems: this.props.item.iditems,
            idpromotora: evento.idpromotora,
            idevento: evento.idevento
        }
        this.props.pesquisasubitem(dados);
    }

        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Cadastro de Preços dos Produtos" subtitulo="Cadastro" descricao="" />
            <Body>                
                <FormProdutosPrecos {...this.props} handleSubmit={this.handleSubmit} />
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        cadastros: state.reducerPesquisaSubitem,
        item: state.reducerPesquisaItem?state.reducerPesquisaItem[0]:state.reducerPesquisaItem,
        precoselecionado: state.reducerProdPrecoSelecionado
    }
}

export default connect(mapStateToProps,{pesquisapreco,pesquisasubitem,subitemselecionado,pesquisaitem})(withRouter(ProdutosPrecos));